<template>
  <main id="create-item-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Anteprima immagine (se presente e se non si sta caricando una nuova immagine) -->
    <div
      v-if="formData.image && typeof formData.image === 'string'"
      class="image-preview"
    >
      <img
        :src="formData.image"
        alt="Anteprima immagine"
        class="mini-image-preview"
      />

      <button v-if="formData.image" class="icons-button" @click="clearImage">
        <i class="clear-image fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Form principale -->
    <form class="create-item-form" @submit.prevent="onUpdateItem">
      <div class="create-item-row">
        <template v-if="category === 'piastrelle'">
          <!-- Marca -->
          <div class="field">
            <label for="item-model">Marca</label>
            <input
              id="item-model"
              type="text"
              v-model="formData.brand"
              placeholder="inserisci"
            />
          </div>
          <!-- Nome Articolo -->
          <div class="field">
            <label for="item-name">Nome articolo *</label>
            <input
              id="item-name"
              type="text"
              v-model="formData.itemName"
              placeholder="inserisci"
            />
          </div>

          <div class="create-item-row">
            <!-- Quantità -->
            <div class="field">
              <label for="quantity">Scatole *</label>
              <input
                id="quantity"
                type="text"
                v-model="formData.boxQuantity"
                placeholder="inserisci"
              />
            </div>
            <!-- Prezzo -->
            <div class="field">
              <label for="price">Prezzo *</label>
              <input
                id="price"
                type="number"
                step="any"
                v-model="formData.price"
                placeholder="inserisci"
              />
            </div>
            <!-- Larghezza -->
            <div class="field">
              <label for="width">Larghezza (cm) *</label>
              <input
                id="width"
                step="any"
                type="number"
                v-model="formData.widthCm"
                placeholder="inserisci"
              />
            </div>
            <!-- Altezza -->
            <div class="field">
              <label for="height">Altezza (cm) *</label>
              <input
                id="height"
                step="any"
                type="number"
                v-model="formData.heightCm"
                placeholder="inserisci"
              />
            </div>
          </div>
          <!-- Data inserimento -->
          <div class="field">
            <label for="date">Data inserimento</label>
            <input
              id="date"
              type="date"
              v-model="formData.entryDate"
              placeholder="inserisci"
            />
          </div>
          <!-- Pezzi per scatola -->
          <div class="field">
            <label for="piecesPerBox">Pezzi per scatola *</label>
            <input
              id="ppbox"
              step="any"
              type="number"
              v-model="formData.piecesPerBox"
              placeholder="inserisci"
            />
          </div>
          <!-- Immagine -->
          <!-- <div class="field">
            <label v-if="imageFileName" for="image"
              >Carica una nuova immagine</label
            >
            <label v-else for="image">Carica un'immagine</label>
            <input
              id="image"
              type="file"
              @change="handleImageUpload"
              accept="image/*"
            />
            -- Visualizza il nome dell'immagine già caricata nell'anteprima --
            <span v-if="imageFileName"
              ><strong>Immagine attualmente caricata:</strong>
              {{ imageFileName }}</span
            >
          </div> -->
        </template>

        <template v-else>
          <!-- Marca -->
          <div class="field">
            <label for="item-model">Marca *</label>
            <input
              id="item-model"
              type="text"
              v-model="formData.brand"
              placeholder="inserisci"
            />
          </div>
          <!-- Serie -->
          <div class="field">
            <label for="item-subBrand">Serie</label>
            <input
              id="item-subBrand"
              type="text"
              v-model="formData.subBrand"
              placeholder="inserisci"
            />
          </div>

          <div class="create-item-row">
            <div class="field">
              <label for="fixtureType">Tipo sanitari *</label>
              <AppSelect
                id="fixtureType"
                v-model="formData.fixtureType"
                :options="fixtureTypeOptions"
                placeholder="— scegli —"
                required
              />
            </div>
            <div class="field">
              <label for="fixturePosition">Posizione *</label>
              <AppSelect
                id="fixturePosition"
                v-model="formData.fixturePosition"
                :options="fixturePositionOptions"
                placeholder="— scegli —"
                required
              />
            </div>
          </div>
          <div class="field">
            <label for="price">Prezzo *</label>
            <input
              id="price"
              type="number"
              step="any"
              v-model="formData.price"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="inWarehouse">Quantità pezzi *</label>
            <input
              id="inWarehouse"
              type="number"
              v-model="formData.inWarehouse"
              placeholder="inserisci"
            />
          </div>
          <div v-if="formData.fixtureType === 'vaso'" class="field">
            <label for="potQuantity">Pezzi Coprivaso *</label>
            <input
              id="potQuantity"
              type="number"
              min="0"
              v-model.number="formData.potQuantity"
              required
            />
          </div>
          <!-- Colore -->
          <div class="field">
            <label for="color">Colore</label>
            <input
              id="color"
              type="text"
              v-model="formData.color"
              placeholder="inserisci"
            />
          </div>
          <hr />
          <!-- Data inserimento -->
          <div class="field">
            <label for="date">Data inserimento</label>
            <input
              id="date"
              type="date"
              v-model="formData.entryDate"
              placeholder="inserisci"
            />
          </div>
          <!-- Immagine -->
          <!-- <div class="field">
            <label v-if="imageFileName" for="image"
              >Carica una nuova immagine</label
            >
            <label v-else for="image">Carica un'immagine</label>
            <input
              id="image"
              type="file"
              @change="handleImageUpload"
              accept="image/*"
            /> -->
          <!-- Visualizza il nome dell'immagine già caricata nell'anteprima -->
          <!-- <span v-if="imageFileName"
              ><strong>Immagine attualmente caricata:</strong>
              {{ imageFileName }}</span
            >
          </div> -->
        </template>
        <!-- Bottone "Aggiorna" -->
        <div class="save-button-container">
          <button
            id="create-item-button"
            type="submit"
            :disabled="!canSave"
            :aria-disabled="!canSave"
            :title="
              !isDirty
                ? 'Modifica almeno uno dei campi'
                : !isValid
                ? 'Compila tutti i campi obbligatori'
                : `${
                    $route.name === 'tiles-edit-item'
                      ? 'Aggiorna piastrella'
                      : 'Aggiorna sanitario'
                  }`
            "
          >
            Aggiorna
          </button>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { isTileValid, isSanitaryValid } from "@/utilities/itemValidation";

export default {
  name: "EditItemPage",
  props: ["itemId"],
  data() {
    return {
      // [sc-49210] Opzioni dei menu a tendina
      fixtureTypeOptions: [
        { value: "vaso", label: "Vaso" },
        { value: "bidet", label: "Bidet" },
        { value: "lavabo", label: "Lavabo" },
        { value: "box doccia", label: "Box doccia" },
        { value: "piatto doccia", label: "Piatto doccia" },
        { value: "vasca", label: "Vasca" },
        { value: "mobile bagno", label: "Mobile bagno" },
        { value: "specchiera", label: "Specchiera" },
        { value: "rubinetteria", label: "Rubinetteria" },
        { value: "idraulica", label: "Idraulica" },
        { value: "altro", label: "Altro" },
      ],
      fixturePositionOptions: [
        { value: "sospeso", label: "Sospeso" },
        { value: "terra", label: "A terra" },
        { value: "mono-blocco", label: "Mono-blocco" },
        { value: "altro", label: "Altro" },
      ],
      // category: "",
      formData: {
        inWarehouse: 0,
        brand: "",
        subBrand: "",
        itemName: "",
        category: this.$route.meta.category,
        boxQuantity: "",
        entryDate: "",
        widthCm: "",
        piecesPerBox: "",
        heightCm: "",
        color: "",
        fixturePosition: "",
        fixtureType: "",
        potQuantity: "",
        price: 0,
        // Qui, se l'articolo ha già un'immagine, potresti inizializzarla con l'URL permanente già presente.
        // image: null,
      },

      originalSnapshot: null, // Per tenere traccia dello stato originale
      hasLoaded: false, // true dopo che i dati sono stati caricati
      errorMessage: "",
      successMessage: "",
    };
  },
  computed: {
    category() {
      return this.$route.meta.category;
    },

    // Se formData.image è una stringa (URL), estrai il nome del file
    imageFileName() {
      if (this.formData.image && typeof this.formData.image === "string") {
        return this.formData.image.split("/").pop();
      }
      return "";
    },

    // [sc-49210] stesse regole della creazione (utilities/itemValidation.js)
    isValid() {
      return this.category === "piastrelle"
        ? isTileValid(this.formData)
        : isSanitaryValid(this.formData);
    },
    canSave() {
      return this.isDirty && this.isValid;
    },
    isDirty() {
      if (!this.hasLoaded) return false;
      const curr = this.snapshotCurrent();
      return JSON.stringify(curr) !== JSON.stringify(this.originalSnapshot);
    },
  },
  methods: {
    ...mapActions(["updateItem", "uploadImage", "removeImage"]),

    // Normalizza i tipi per evitare “falsi dirty” (stringhe vs numeri)
    normalizeForCompare(src) {
      const str = (v) => (v == null ? "" : String(v).trim());
      const num = (v) => (v === "" || v == null ? null : Number(v));

      // Nota: includi SOLO i campi che vuoi considerare per il confronto
      return {
        category: str(src.category),
        itemName: str(src.itemName),
        brand: str(src.brand),

        // piastrelle
        boxQuantity: num(src.boxQuantity),
        widthCm: num(src.widthCm),
        heightCm: num(src.heightCm),
        piecesPerBox: num(src.piecesPerBox),

        // sanitari
        subBrand: str(src.subBrand),
        fixtureType: str(src.fixtureType),
        fixturePosition: str(src.fixturePosition),
        potQuantity: num(src.potQuantity),
        color: str(src.color),

        // comuni
        price: num(src.price),
        inWarehouse: num(src.inWarehouse),
        entryDate: str(src.entryDate),

        // immagine: se è un File segno un token speciale (qualunque file ≠ url)
        image:
          typeof src.image === "string"
            ? str(src.image)
            : src.image instanceof File
            ? "__file__"
            : "",
      };
    },

    snapshotCurrent() {
      return this.normalizeForCompare(this.formData);
    },

    async fetchItemData() {
      try {
        this.errorMessage = "";
        const response = await this.$axios.get(`item/${this.itemId}`);
        // console.log("fetchItemData response: ", response);

        // console.log("response item x id: ", response);

        if (response.status === 200) {
          // console.log("arrivo qui?");
          const itemData = response.data.item;
          this.formData = { ...itemData };
          this.formData.entryDate = itemData.entryDate
            ? itemData.entryDate.slice(0, 10)
            : "";
          // Se l'articolo ha già un'immagine, la salvi come stringa (URL permanente)
          //   this.formData.image = itemData.image;

          this.$nextTick(() => {
            this.successMessage =
              response.data?.message ||
              `Dati dell'articolo con ID ${this.itemId} caricati con successo!`;
            this.$toast.success(this.successMessage);
            // snapshot iniziale normalizzato
            this.originalSnapshot = this.snapshotCurrent();
            this.hasLoaded = true;
          });
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message ||
          "Impossibile caricare i dati dell'articolo.";
        this.$toast.error(this.errorMessage);
      }
    },

    async clearImage() {
      // Controlla se formData.image esiste e se è una stringa (cioè l'URL permanente)
      if (!this.formData.image || typeof this.formData.image !== "string") {
        console.warn("Nessuna immagine presente per questo item");
        return;
      }
      // Estrai l'objectName dall'URL (assumendo che l'URL termini con il nome del file)
      const objectName = this.formData.image.split("/").pop();
      const conferma = window.confirm(
        "Sei sicuro di voler cancellare l'immagine?"
      );
      if (!conferma) return;

      try {
        await this.removeImage({ itemId: this.itemId, objectName });
        this.successMessage = "Immagine rimossa con successo.";
        this.formData.image = null; // Resetta l'immagine nel form
      } catch (error) {
        console.error(error);
        this.errorMessage = "Errore nella rimozione dell'immagine.";
        this.$toast.error(this.errorMessage);
      }

      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, 1500);
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = file; // Seleziona il file solo se l'utente ne carica uno nuovo
      }
    },

    async onUpdateItem() {
      this.errorMessage = "";
      this.successMessage = "";
      try {
        let imageUrl = "";

        // Se l'immagine è un file (cioè l'utente ha selezionato una nuova immagine),
        // effettua l'upload e costruisci l'URL permanente
        if (this.formData.image && this.formData.image instanceof File) {
          const uploadResponse = await this.$store.dispatch("uploadImage", {
            image: this.formData.image,
          });
          imageUrl = uploadResponse.data.url;
        } else if (typeof this.formData.image === "string") {
          // Se l'immagine è già una stringa (URL permanente), la mantieni
          imageUrl = this.formData.image;
        }

        // Prepara il payload per aggiornare l'articolo
        // Includi il campo image solo se è stato aggiornato (cioè se imageUrl è valorizzato)
        const payload = {
          brand: this.formData.brand,
          subBrand: this.formData.subBrand,
          price: this.formData.price,
          category: this.category,
          piecesPerBox: this.formData.piecesPerBox,
          fixtureType: this.formData.fixtureType,
          fixturePosition: this.formData.fixturePosition,
          potQuantity: this.formData.potQuantity,
          color: this.formData.color,
          widthCm: this.formData.widthCm,
          heightCm: this.formData.heightCm,
          itemName: this.formData.itemName,
          inWarehouse: this.formData.inWarehouse,
          boxQuantity: this.formData.boxQuantity,
          entryDate: this.formData.entryDate,
          ...(imageUrl && { image: imageUrl }),
        };

        console.log("editItem payload: ", payload);

        const response = await this.$store.dispatch("updateItem", {
          itemId: this.itemId,
          payload,
        });

        if (response.status === 200) {
          this.successMessage =
            response.data?.message || "Articolo aggiornato con successo!";
          this.$toast.success(this.successMessage);

          // allinea lo snapshot originale lo stato attuale
          this.originalSnapshot = this.snapshotCurrent();

          // Redirect alla pagina stock dopo un breve timeout
          setTimeout(() => {
            this.$router.push({ name: "stock" });
          }, 1000);
        }
      } catch (error) {
        console.error("Errore durante l'aggiornamento dell'articolo: ", error);
        if (error.response?.status === 409) {
          this.errorMessage =
            error.response.data?.message ||
            "Conflitto nei dati, chiave univoca 'Nome articolo' già presente.";
          console.log(this.errorMessage);
          this.$toast.error(this.errorMessage);
        } else {
          this.errorMessage =
            error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante l'aggiornamento dell'articolo.";
          this.$toast.error(this.errorMessage);
        }
        this.successMessage = "";
      }
    },
  },
  mounted() {
    this.fetchItemData();
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
